import React from "react";

const ARTISAN = "/hero_atelier.jpg";
const YARN = "https://images.unsplash.com/photo-1550376026-7375b92bb318?w=1200";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20">
      {/* Intro */}
      <div className="text-center max-w-2xl mx-auto">
        <span className="overline">La nostra storia</span>
        <h1 className="font-serif text-5xl sm:text-6xl mt-5 tracking-tight leading-tight">
          Mi chiamo <em className="italic text-alimi-gold">Evelyn</em>.
        </h1>
        <div className="alimi-divider mt-7" />
        <p className="text-base text-alimi-inkSoft mt-8 leading-relaxed">
          Vengo dalla Campania e l'uncinetto è la mia lingua più antica.
          Alimì nasce da un ricordo d'infanzia, da una persona che amavo
          tantissimo e dalla voglia di trasformare un gesto familiare in
          un piccolo atelier di creazioni fatte a mano.
        </p>
      </div>

      {/* Story */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-24 items-center">
        <img src={ARTISAN} alt="Evelyn al lavoro" className="aspect-[4/5] object-cover w-full" />
        <div>
          <span className="overline">Il ricordo</span>
          <h2 className="font-serif text-3xl sm:text-4xl mt-4 tracking-tight leading-tight">
            Otto anni, le mani di zia <em className="italic">Eliana</em>.
          </h2>
          <p className="text-sm text-alimi-inkSoft leading-relaxed mt-6">
            Avevo otto anni quando mia zia Eliana mi mise in mano il primo uncinetto.
            Mi insegnò il punto basso, il punto alto, la pazienza di sciogliere e
            ricominciare. Le sue mani sapevano trasformare un gomitolo in qualcosa
            che prima non esisteva — e in qualche modo, anche io.
          </p>
          <p className="text-sm text-alimi-inkSoft leading-relaxed mt-4">
            Alimì nasce nel suo ricordo. Ogni pezzo che creo porta con sé il filo
            invisibile che lei mi ha messo tra le dita tanti anni fa.
          </p>
        </div>
      </div>

      {/* Materials */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-24 items-center">
        <div className="order-2 lg:order-1">
          <span className="overline">I materiali</span>
          <h2 className="font-serif text-3xl sm:text-4xl mt-4 tracking-tight">
            Filati naturali, scelti con cura.
          </h2>
          <p className="text-sm text-alimi-inkSoft leading-relaxed mt-6">
            Lavoro con cotone biologico, lana merino, lino, viscosa, rafia e fibre
            naturali certificate. La materia prima fa la differenza: cerco qualità,
            sostenibilità e un tatto che parli al cuore prima ancora che agli occhi.
          </p>
          <p className="text-sm text-alimi-inkSoft leading-relaxed mt-4">
            Ogni creazione è un pezzo unico, leggermente diverso dal precedente —
            è la firma del fatto a mano, la traccia umana che lo rende vivo.
          </p>
        </div>
        <img src={YARN} alt="Filati naturali" className="aspect-[4/5] object-cover w-full order-1 lg:order-2" />
      </div>

      {/* Promise */}
      <div className="mt-28 text-center max-w-xl mx-auto">
        <span className="overline">La promessa</span>
        <h2 className="font-serif text-3xl sm:text-4xl mt-4 tracking-tight">
          Creazioni che <em className="italic text-alimi-gold">raccontano</em>.
        </h2>
        <p className="text-sm text-alimi-inkSoft leading-relaxed mt-6">
          Ogni borsa, ogni accessorio, ogni capo Alimì porta con sé una storia.
          Quella di zia Eliana, la mia, e quella di chi sceglierà di indossarlo.
        </p>
        <p className="font-serif italic text-alimi-gold text-xl mt-10">— Evelyn</p>
      </div>
    </div>
  );
}
